module.exports = __webpack_public_path__ + "img/arrows-up-down-dark-white.56567daa.svg";